/**
 * Set up main menu.
 *
 * @param { string } msg Message to console log.
 */
// import './scripts/*.js'